'use client';

import classnames from 'classnames';

import type { DropdownIconProps } from './DropdownIcon.types';

import styles from './DropdownIcon.module.scss';

export function DropdownIcon({
  ref,
  style,
  className,
  size = 'md',
  closed = true,
  disabled = false,
  error = false,
  testId = 'ui-dropdown-icon',
  ...rest
}: DropdownIconProps) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(
        styles['icon'],
        styles[`icon--${size}`],
        !closed && styles['icon--open'],
        closed && styles['icon--closed'],
        disabled && styles['icon--disabled'],
        error && styles['icon--error'],
        className,
      )}
      aria-hidden="true"
      data-testid={testId}
      {...rest}
    />
  );
}
